import ThFavoritesViewAbstract from '@/js/common/components/thFavorites/thFavoritesAbstract';
import HotelCategoriesRepository from '@/js/common/Domain/Repository/HotelCategories';
import HotelTrackingService from '@ve/pages/hotel/analytics/yandexAnalytics/hotelTrackingService';

const ThFavoritesHotelView = ThFavoritesViewAbstract.extend({
    getTourCriteria() {
        const tourCriteria = this.model.get('searchData').clone();

        tourCriteria.set('hotelCategories', new HotelCategoriesRepository()); //to prevent wrong categories on search page
        return tourCriteria;
    },
    getMinPrice() {
        return this.searchPageModel.get('minPriceBySearchDates');
    },
    initSubscribes() {
        ThFavoritesViewAbstract.prototype.initSubscribes.call(this);
        this.model.on('change:searchData', $.proxy(this.updateFavoriteState, this));
    },
    trackingClickTh(clickType) {
       const hotelTrackingService = new HotelTrackingService();
       const isUserAuth = this.viewModel.get('viewModelAuthorized');

       hotelTrackingService.hotelThClick(isUserAuth, clickType);
    },
});

export default ThFavoritesHotelView;